module.exports = __webpack_public_path__ + "static/media/ic-arrow-up.8d64ba9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-arrow-up.svg
// module id = 599
// module chunks = 14